import Link from 'next/link'
import React from 'react'

import { Text } from '@wartek-id/text'

import PlayIcon from 'assets/icons/play-fill.svg'
import { youtubeDurationToHms } from 'utils/datetime'

interface VideoCardProps {
  thumbnailUrl: string
  title: string
  duration: string
  videoId: string
  playlistId: number
}

const VideoCard = ({
  playlistId,
  thumbnailUrl,
  title,
  duration,
  videoId,
}: VideoCardProps) => {
  return (
    <div className="relative flex items-start px-4 mb-4 last:mb-0">
      <div className="flex-shrink-0 flex-grow-0 relative rounded">
        <img
          className="relative w-[118px] h-[64px] object-cover object-center rounded brightness-75"
          src={thumbnailUrl ?? `https://img.youtube.com/vi/${videoId}/1.jpg`}
          alt=""
        />
        <PlayIcon className="absolute top-1/2 left-1/2 -ml-3 -mt-3 text-white fill-current z-10" />
      </div>
      <div className="ml-3">
        <div className="mb-1 leading-none">
          <Link
            href={`/playlists/video?id=${playlistId}&video=${videoId}`}
            passHref
          >
            <Text
              as="a"
              variant="body"
              className="overlay-link line-clamp-2 overflow-ellipsis"
            >
              {title}
            </Text>
          </Link>
        </div>
        <Text variant="helper" color="subdued">
          {youtubeDurationToHms(duration)}
        </Text>
      </div>
    </div>
  )
}

export default VideoCard
